import api from '@/utils/api/apiClient'

export const fetchContent = params => {
  const search = new URLSearchParams()
  if (params?.type) search.set('type', params.type)
  if (params?.locale) search.set('locale', params.locale)
  return api.get(`/content${search.toString() ? `?${search}` : ''}`)
}

export const fetchContentBySlug = (slug, locale) => {
  const search = locale ? `?locale=${locale}` : ''
  return api.get(`/content/${slug}${search}`)
}
